// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Projects_wrapper__ISzFY","title":"Projects_title__YS1LL"};